import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ca9175f4")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "home-subtitle max-w-md mx-auto mt-[32px]" }, "Collect fees from pool and rebalances automatically.", -1)
const _hoisted_2 = {
  key: 0,
  class: "mt-[60px] flex w-full justify-center"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Start earning ")
const _hoisted_4 = {
  key: 1,
  class: "my-[80px] flex w-full justify-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "boost flex my-12" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "boost-value" }, "2.5x"),
      /*#__PURE__*/_createTextVNode(" Up to current APR ")
    ]),
    /*#__PURE__*/_createElementVNode("h5", { class: "boost-info self-center" }, "Boost liquidity mining yields up to 2.5x")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "boost flex  my-12" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "boost-value" }, "30%"),
      /*#__PURE__*/_createTextVNode(" Up to current APR ")
    ]),
    /*#__PURE__*/_createElementVNode("h5", { class: "boost-info self-center" }, "Boost liquidity mining yields up to 2.5x")
  ])
], -1)
const _hoisted_6 = { class: "text-left self-end mb-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "balancer-info mb-[16px]" }, [
  /*#__PURE__*/_createTextVNode(" Portfolios that "),
  /*#__PURE__*/_createElementVNode("span", { class: "yield" }, "generate yield "),
  /*#__PURE__*/_createTextVNode(" and rebalance automatically. ")
], -1)
_popScopeId()

import { computed } from 'vue';

import AppHero from '@/components/heros/AppHero.vue';
import useFathom from '@/composables/useFathom';
import { EXTERNAL_LINKS } from '@/constants/links';
import useWeb3 from '@/services/web3/useWeb3';
import useBreakpoints from '@/composables/useBreakpoints';
import HeroConnectWalletButton from './HeroConnectWalletButton.vue';
import ArrowDownIcon2 from '../_global/icons/ArrowDownIcon2.vue';

/**
 * COMPOSABLES
 */

export default _defineComponent({
  setup(__props) {

const { isWalletReady, isWalletConnecting } = useWeb3();
const { trackGoal, Goals } = useFathom();
const { upToMediumBreakpoint, isMobile, isDesktop } = useBreakpoints();
/**
 * COMPUTED
 */
const classes = computed(() => ({
  //['h-72']: !isWalletReady.value && !isWalletConnecting.value,
  //['h-46']: isWalletReady.value || isWalletConnecting.value,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppHero, {
    class: _normalizeClass([{'mt-[200px]':_unref(isDesktop),'mb-10':_unref(isMobile)}, "app-hero"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("h1", {
        class: _normalizeClass(["home-title mx-auto", {'text-[84px] leading-[104px]':_unref(isDesktop),'text-[44px] leading-[50px]':_unref(isMobile)}])
      }, "Put your assets to work.", 2),
      _hoisted_1,
      (!_unref(isWalletReady) && !_unref(isWalletConnecting))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(HeroConnectWalletButton, { class: "mr-[16px]" }),
            _createElementVNode("a", {
              href: "#hot-pools",
              rel: "noreferrer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(trackGoal)(_unref(Goals).ClickStartEarning))),
              class: "start-earning-button"
            }, [
              _hoisted_3,
              _createVNode(ArrowDownIcon2, { class: "inline ml-[20px]" })
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(isDesktop))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("a", {
                href: "https://medium.com/@PolarisFinance/polaris-dex-917e45c4869c",
                target: "_blank",
                rel: "noreferrer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(trackGoal)(_unref(Goals).ClickHeroLearnMore))),
                class: "read-button"
              }, " Read our medium ")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})